import axios from 'axios';
const speechApi = axios.create({});

let leftchannel = [];
/* let rightchannel = []; */
let recorder = null;
let recordingLength = 0;
/* let volume = null; */
let mediaStream = null;
const sampleRate = 44100;
let context = null;
let blob = null;
let tracks = [];

/* STT current(11/18) ios만 적용 */
/* export const requestSpeechText = async sendSpeech => {
  console.log(sttResult);

  const res = await voiceApi.post('/Voice', { content: sendSpeech });
  console.log(res);
}; */

  function CLOG(log) {
    console.log(log);
  }

  export const stopAudioOnly = (streaming) => {
    const trackState = streaming.getTracks();
    trackState[0].stop();
  };

  function gotStream(stream){
    // creates the audio context
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    context = new AudioContext();
    tracks = stream;
    // creates an audio node from the microphone incoming stream
    mediaStream = context.createMediaStreamSource(stream);
    // bufferSize: the onaudioprocess event is called when the
    // buffer is full
    const bufferSize = 2048;
    const numberOfInputChannels = 1;
    const numberOfOutputChannels = 1;
    if (context.createScriptProcessor) {
        recorder = context.createScriptProcessor(
        bufferSize,
        numberOfInputChannels,
        numberOfOutputChannels
        );
    } else {
        recorder = context.createJavaScriptNode(
        bufferSize,
        numberOfInputChannels,
        numberOfOutputChannels
        );
    }
    recorder.onaudioprocess = function (stream1) {
        const ch0 = new Float32Array(stream1.inputBuffer.getChannelData(0));
        leftchannel.push(ch0);

        // const ch1 = new Float32Array(e.inputBuffer.getChannelData(1));
        // rightchannel.push(ch1);
        recordingLength += bufferSize;
    };
    mediaStream.connect(recorder);
    recorder.connect(context.destination);
  };

  export const encode = async (interleaved) => {
    const buffer = new ArrayBuffer(44 + interleaved.length * 2);
    const view = new DataView(buffer);

    const numChannels = 1;
    /* RIFF identifier */
    writeString(view, 0, "RIFF");
    /* RIFF chunk length */
    view.setUint32(4, 36 + interleaved.length * 2, true);
    /* RIFF type */
    writeString(view, 8, "WAVE");
    /* format chunk identifier */
    writeString(view, 12, "fmt ");
    /* format chunk length */
    view.setUint32(16, 16, true);
    /* sample format (raw) */
    view.setUint16(20, 1, true);
    /* channel count */
    view.setUint16(22, numChannels, true);
    /* sample rate */
    view.setUint32(24, sampleRate, true);
    /* byte rate (sample rate * block align) */
    view.setUint32(28, sampleRate * 4, true);
    /* block align (channel count * bytes per sample) */
    view.setUint16(32, numChannels * 2, true);
    /* bits per sample */
    view.setUint16(34, 16, true);
    /* data chunk identifier */
    writeString(view, 36, "data");
    /* data chunk length */
    view.setUint32(40, interleaved.length * 2, true);

    return view;
  };

  export const startRecord = async () => {
    console.log("들어옴")
    const constraints = {
    audio: true,
    video: false,
    }
    function errorCallback(error) {
        CLOG("navigator.getUserMedia error: ", error);
    }
    navigator.mediaDevices.getUserMedia(constraints)
      .then(gotStream)
      .catch(errorCallback);
  };

  /* 음성 파일 다운로드 */
/*       function downloadWav(){
        if (blob == null) {
            return;
        }
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = "sample2.wav";
        a.click();
        window.URL.revokeObjectURL(url);
    } */

    export const uploadToServer = async (reqBlob) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(reqBlob);
  
  /*       const res = await speechApi.post('/SpeechText', { wavefile: reader.result });
        console.log(res.data) */
        
        reader.onload = async () => {
          try {
            const res = await speechApi.post('/SpeechText', { wavefile: reader.result });
            console.log(res.data);
            resolve(res.data);         
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = (error) => {
          reject(error);
        };

      });
    };


/*     const uploadToServer = async (reqBlob) => {
      const reader = new FileReader();
      reader.readAsDataURL(reqBlob);
      reader.onloadend = function () {
        console.log(reader.result);
        axios({
          url: "/SpeechText",
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-type": "application/json;charset=UTF-8",
          },
          data: {
            wavfile: reader.result,
          },
        })
          .then((response) => {
            return response;
          })
          .catch(function (err) {
            console.error(err);
          });
      };
    }; */

  export const flattenArray = async (channelBuffer, Length) => {
    const result = new Float32Array(Length);
    let offset = 0;
    for (let i = 0; i < channelBuffer.length; i++) {
      const buffer = channelBuffer[i];
      result.set(buffer, offset);
      offset += buffer.length;
    }
    return result;
  };

  /* 2채널녹음 */
/*   const interleave = (inputL, inputR) => {
    let length = inputL.length + inputR.length;
    let result = new Float32Array(length);

    let index = 0,
      inputIndex = 0;

    while (index < length) {
      result[index++] = inputL[inputIndex];
      result[index++] = inputR[inputIndex];
      inputIndex++;
    }
    return result;
  }; */

  export const floatTo16BitPCM = async (output, offset, input) => {
    for (let i = 0; i < input.length; i++, offset += 2) {
      const s = Math.max(-1, Math.min(1, input[i]));
      output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
  };

  export const writeString = (view, offset, string) => {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
    }
  };

  /* stop record */
  export const stopRecord = async () => {
    recorder.disconnect(context.destination);
    mediaStream.disconnect(recorder);
    stopAudioOnly(tracks);
    // console.log(recordingLength)
    // leftchannel = flattenArray(leftchannel, recordingLength);
    // rightchannel = flattenArray(rightchannel, recordingLength);
    // console.log('rightchannel.length', rightchannel.length);
    // let interleaved = interleave(leftchannel, rightchannel);

    const interleaved = await flattenArray(leftchannel, recordingLength);
    // console.log('leftchannel.length', leftchannel.length);
    // console.log('interleaved.length', interleaved.length);
    const view = await encode(interleaved);
    floatTo16BitPCM(view, 44, interleaved);


    blob = new Blob([view], {
      type: "audio/wav",
    });

/*     downloadWav(blob) */
    let resultText = await uploadToServer(blob);

    if(resultText !== ''){
      console.log("###resultText ",resultText);
    }else{
      resultText = '음성인식이 되지 않았습니다'
    }

    /* 초기화 */
    leftchannel = [];
  /*   rightchannel = []; */
    recorder = null;
    recordingLength = 0;
    /* volume = null; */
    mediaStream = null;
    context = null;
    blob = null;

    return resultText;
  };
